import script from "./MenuSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MenuSidebar.vue?vue&type=style&index=0&id=1e6f414a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6f414a"]])

export default __exports__